// detectCityByPosition — devuelve { city, currency } según GPS.
// Bounding box muy laxo, suficiente para detectar la ciudad del viaje.

const CITY_BOXES = [
  { city: "Budapest", currency: "HUF", bbox: { minLat: 47.35, maxLat: 47.62, minLng: 18.90, maxLng: 19.32 } },
  { city: "Praga", currency: "CZK", bbox: { minLat: 49.95, maxLat: 50.20, minLng: 14.20, maxLng: 14.70 } },
  { city: "Terezín", currency: "CZK", bbox: { minLat: 50.45, maxLat: 50.55, minLng: 14.10, maxLng: 14.22 } },
  { city: "Israel", currency: "ILS", bbox: { minLat: 29.45, maxLat: 33.30, minLng: 34.20, maxLng: 35.90 } },
  { city: "Madrid", currency: "EUR", bbox: { minLat: 40.30, maxLat: 40.55, minLng: -3.85, maxLng: -3.55 } },
  { city: "Santiago", currency: "CLP", bbox: { minLat: -33.65, maxLat: -33.30, minLng: -70.95, maxLng: -70.45 } },
];

export function detectCity(position) {
  if (!position) return null;
  const { lat, lng } = position;
  for (const c of CITY_BOXES) {
    const b = c.bbox;
    if (lat >= b.minLat && lat <= b.maxLat && lng >= b.minLng && lng <= b.maxLng) {
      return { city: c.city, currency: c.currency };
    }
  }
  return null;
}
